var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDegenTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "degen_tip_icon",
    "data-name": "degen tip icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 34,
    height: 34,
    rx: 13,
    transform: "translate(34 34) rotate(180)",
    fill: "#6000ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M43.24,45.893a4.925,4.925,0,0,0-1.656.5,3.367,3.367,0,0,0-2,1.958,3.3,3.3,0,0,1,1.145.936,7.161,7.161,0,0,1,1.078,2.074,36.26,36.26,0,0,1,1.152,4.649l1.519.191s2-1.49,2.12-2.53c.034-.308-.489-.79-.489-.79s.313-.349.255-.6a2.7,2.7,0,0,0-.547-.778.666.666,0,0,0,.005-.537c-.183-.271-1-.452-1-.452a.6.6,0,0,1,0-.542s.779-.679.575-.932A12.977,12.977,0,0,0,44.414,48C44.4,46.371,43.931,45.885,43.24,45.893Zm-5.4,3.1c-2.515.015-3.65,3.782-5,4.558-2.293,1.256-5.773-.6-7.655,1.162-1.935,1.817-2.509,3.625-1.689,7.15l-1,2.97c-.394,1.965-.743,1.622-.5,3.209,2-.051,4-.086,6,0l.14-.863-1.372-.855a6.267,6.267,0,0,1,1.079-2.739A5.154,5.154,0,0,0,29,61.021l.949.008a5.074,5.074,0,0,1-.99,2.648A9.149,9.149,0,0,0,38.082,61.2,15.6,15.6,0,0,0,36.115,57l.77-.555c1.881,2.712,2.9,6.98,3.477,9.82a8.557,8.557,0,0,0-.921.348c.018.479.055.957.087,1.436,1.643-.112,3.28-.038,4.935,0,.909-3.587-.541-6.213-2.043-9.889-1.1-3.874-.97-8.5-3.908-9.094a3.3,3.3,0,0,0-.67-.067Zm.534,13.166a6.794,6.794,0,0,1-1.034.806c-.268.175-.559.344-.868.505l-.718,3.318-.575.259-.058,1h3.433l-.091-2.036.778-.351c-.211-1-.514-2.267-.867-3.5Zm-9.855,2.252.825,3.631h4.9l-.081-.981-1.3-.3-.24-2.03a8.335,8.335,0,0,1-4.1-.315Z",
    transform: "translate(-17.259 -39.969)",
    fill: "#ebecff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegenTip);
export default __webpack_public_path__ + "static/media/degen-tip.93df2871.svg";
export { ForwardRef as ReactComponent };